export const QUESTION_INCREMENTS_KEY = 'Increments';

export const VALIDATOR_TYPES = {
  BLANK_INPUT: 'BlankInput',
  RANGE: 'Range',
  REQUIRED : 'Required',
  EVALUATE : 'Evaluate',
  RANGE_FROM_LOOKUP : 'Range-FromLookup',
  STG_VALIDATOR : 'stg-validator',
  LTG_VALIDATOR : 'ltg-validator'
};

export const NoRevisions = 'norevisions';

export const TOOLTIP_TYPES = {
  ACCORDION: 'Accordion',
  TOOLTIP: 'Tooltip'
}

export const QuestionTypes = {
  Checkbox: 'Checkbox',
  Toggle: 'Toggle',
  Checkboxes: 'Checkboxes',
  TextArea: 'TextArea',
  Date: 'Date',
  SkilledCare_EnhancedTag : 'LevelOfAbility - Enhanced Tag',
  DynamicSubHead_NewApproaches : 'DynamicSubHead-NewApproaches'
}
export const GRID = 'Grid';

export const EVAL_DATE = 'EvalDate';

export const SelectionType = {
  SINGLE: 'single',
  MULTIPLE: 'multiple'
};